import { Quote } from '@angular/compiler';
import { Bill } from 'src/app/models/bill';
import { Consignee } from 'src/app/models/consignee';
import { Customer } from 'src/app/models/customer';
import { FilterQuote } from 'src/app/models/filter-quote';
import { Master } from 'src/app/models/master';
import { NumberBill } from 'src/app/models/number-bill';
import { Warehouse } from 'src/app/models/warehouse';

export class ConfirmDialogTicket {
    title: string;
    message: string = "-";
    labelCancel : string = "Cancel";
    labelOk : string = "Ok";
    fnOK : object;
    flagRespuesta : boolean=false;
    documento:string;
    wr:Warehouse;
    ms:Master;
    c: Customer;
    n: NumberBill;
    bill: Bill;
    btn: string;
    quote: FilterQuote;
    consignee: Consignee;
  }